import PropTypes from "prop-types";
import React, { Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { connect } from "react-redux";
import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic";

// home pages
const HomeFashion = lazy(() => import("./pages/home/HomeFashion"));
const Pregnancy = lazy(() => import("./pages/other/Pregnancy"));
// other pages
const Contact = lazy(() => import("./pages/other/Contact"));
const Wedding = lazy(() => import("./pages/other/Wedding"));
const Newborn = lazy(() => import("./pages/other/Newborn"));

const NotFound = lazy(() => import("./pages/other/NotFound"));
const Birthday = lazy(() => import("./pages/other/Birthday"));
const Family = lazy(() => import("./pages/other/Family"));
const App = () => {
  return (
    <ToastProvider placement="bottom-left">
      <BreadcrumbsProvider>
        <Router>
          <ScrollToTop>
            <Suspense
              fallback={
                <div className="flone-preloader-wrapper">
                  <div className="flone-preloader">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              }
            >
              <Switch>
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={HomeFashion}
                />

                {/* Other pages */}
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={Wedding}
                />
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={Pregnancy}
                />
                <Route

                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={Newborn}
                />
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={Family}
                />
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={Birthday}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/"}
                  component={Contact}
                />

                <Route
                  path={process.env.PUBLIC_URL + "/"}
                  component={NotFound}
                />

                <Route exact component={NotFound} />
              </Switch>
            </Suspense>
          </ScrollToTop>
        </Router>
      </BreadcrumbsProvider>
    </ToastProvider>
  );
};

App.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(App);
